export default {
  namespaced: true,
  state: {
    open: false,
    position: {x: 0, y: 0},
    target: null,
    targetOriginal: null,
  },
  mutations: {
    setOpen (state, isOpen) {
      state.open = isOpen;
    },
    setPosition (state, coords) {
      state.position = coords;
    },
    setTarget (state, target) {
      state.target = target;
      state.targetOriginal = JSON.parse(JSON.stringify(target));
    },
  },
};